import httpClient from "./http";
const actionScope = `loader`;

export function setupInterceptors({ dispatch }) {
    let requestsPending = 0;
  
    const req = {
      pending: () => {
        requestsPending++;
        dispatch(`${actionScope}/show`);
      },
      done: () => {
        requestsPending--;
  
        if (requestsPending <= 0) {
          dispatch(`${actionScope}/hide`);
        }
      }
    };
  
    httpClient.interceptors.request.use(
      config => {
        req.pending();
  
        return config;
      },
      error => {
        requestsPending--;
  
        req.done();
  
        return Promise.reject(error);
      }
    );
  
    httpClient.interceptors.response.use(response => {
        req.done();  
        return response;
      },
      error => {
        req.done();  
         return Promise.reject(error);
      }
    );
  }
  